export var OcvInAppFeedback = 'ocv-inapp-feedback';
export var CentroDataSourcesString = 'centro.hvc.feedback.initOptions';
export var TelemetryPrefix = 'InAppFeedback Loader';
export var inappFeedbackLoaderVersionPrefix = 'inapp-feedback-loader v';
export { CentroUrlProd, PerfPrefix, DefaultMajorVersion, guidRegexPattern } from '@ms/ocv-inapp-feedback-shared';
